var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('div', { staticClass: "task-center" }, [_c('el-popover', { attrs: { "placement": "top-end", "width": "364", "trigger": "hover", "popper-class": "task-center-popper", "visible-arrow": false }, on: { "show": _vm.handleShow }, model: { value: _vm.visible, callback: function callback($$v) {
        _vm.visible = $$v;
      }, expression: "visible" } }, [_c('task-center-enter', { attrs: { "slot": "reference", "badge": _vm.badge, "dark": _vm.dark }, slot: "reference" }), _vm._v(" "), _c('task-center-list', { directives: [{ name: "loading", rawName: "v-loading", value: _vm.loading, expression: "loading" }], attrs: { "data": _vm.taskList }, on: { "jump": _vm.handleClick } })], 1)], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };